import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

export default function FilterPage({ onFilter }) {
  const [namaProdukList, setNamaProdukList] = useState([]);
  const [kategoriList, setKategoriList] = useState([]);
  const [selectedNamaProduk, setSelectedNamaProduk] = useState([]);
  const [selectedKategori, setSelectedKategori] = useState([]);

  useEffect(() => {
    // Fetch unique nama produk
    supabase
      .from('products')
      .select('nama produk')
      .then(({ data }) => {
        if (data) {
          const unique = [...new Set(data.map((d) => d['nama produk']))];
          setNamaProdukList(unique.filter(Boolean));
        }
      });
    // Fetch unique kategori
    supabase
      .from('products')
      .select('kategori')
      .then(({ data }) => {
        if (data) {
          const unique = [...new Set(data.map((d) => d.kategori))];
          setKategoriList(unique.filter(Boolean));
        }
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter({ namaProduk: selectedNamaProduk, kategori: selectedKategori });
  };

  return (
    <div style={{ maxWidth: 500, margin: '40px auto' }}>
      <h2>Filter Katalog Produk</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nama Produk (multi-select):</label>
          <select
            multiple
            value={selectedNamaProduk}
            onChange={(e) =>
              setSelectedNamaProduk(
                Array.from(e.target.selectedOptions, (opt) => opt.value)
              )
            }
            style={{ width: '100%', minHeight: 80 }}
          >
            {namaProdukList.map((nama) => (
              <option key={nama} value={nama}>
                {nama}
              </option>
            ))}
          </select>
        </div>
        <div style={{ marginTop: 20 }}>
          <label>Kategori (multi-select):</label>
          <select
            multiple
            value={selectedKategori}
            onChange={(e) =>
              setSelectedKategori(
                Array.from(e.target.selectedOptions, (opt) => opt.value)
              )
            }
            style={{ width: '100%', minHeight: 80 }}
          >
            {kategoriList.map((kat) => (
              <option key={kat} value={kat}>
                {kat}
              </option>
            ))}
          </select>
        </div>
        <button type="submit" style={{ marginTop: 30, width: '100%' }}>
          Tampilkan Katalog
        </button>
      </form>
    </div>
  );
}
